export const twRounded = {
  "sm": "tw-rounded-sm",
  "base": "tw-rounded-md",
  "lg": "tw-rounded-lg",
  "xl": "tw-rounded-xl",
  "2xl": "tw-rounded-2xl",
  "3xl": "tw-rounded-3xl",
};
